<template>
  <v-container id="dashboard" fluid tag="section">
    <!-- NOT AUTHORIZED-->
     <v-row v-if="!hasAuthoriztion">
      <v-col cols="12">
        <h2>
          <v-icon color="error">mdi-alert</v-icon>
          {{ $t("NotAuthorized") }}
        </h2>
      </v-col>
    </v-row>
    <!-- OPTIONS & MANAGEMENT WIDGETS -->
    <v-row v-if="userLevelAboveAdmin && hasAuthoriztion">
      <v-col cols="12">
        <v-card class="my-0">
          <v-card-title> {{ $t("trustDeposit.queryPeriod") }}</v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" md="6">
                  <DateRangePicker
                    @update="onDateRangeUpdated"
                    :def-dates="dates"
                    :show-clear-btn="true"
                  >
                  </DateRangePicker>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions class="d-flex justify-end">
            <v-btn
              @click.prevent="fetchDepositReport"
              color="warning"
              :loading="loading"
              :disabled="dates.length !== 2 || loading"
            >
              <v-icon left>mdi-magnify</v-icon>
              {{ $t("trustDeposit.searchButton") }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>

    <!-- LIST OF logs -->
    <v-row v-if="userLevelAboveAdmin && hasAuthoriztion">
      <v-col cols="12">
        <v-card>
          <v-card-text>
            <v-data-table
              :items="dailySettlements"
              :items-per-page="-1"
              hide-default-header
              hide-default-footer
            >
              <!-- 自定義表頭 -->
              <template v-slot:header>
                <thead>
                  <!-- 第一層表頭 -->
                  <tr>
                    <th rowspan="2">
                      {{ $t("trustDeposit.transactionDate") }}
                    </th>
                    <th colspan="2" v-for="group in acquirerGroups" :key="group.acquirerGroup"> 
                      {{ group.acquirerName }} {{ $t("trustDeposit.total.label") }}
                    </th>
                    <th colspan="2">{{ $t("trustDeposit.total.daily") }}</th>
                  </tr>
                  <!-- 第二層表頭 -->
                  <tr>
                    <template v-for="group in acquirerGroups"> 
                      <th :key="group.acquirerGroup + '-count'" class="border-left">{{ $t("trustDeposit.transactions") }}</th>
                      <th :key="group.acquirerGroup + '-amount'">{{ $t("trustDeposit.amount") }}</th>
                    </template>
                    <th class="border-left">{{ $t("trustDeposit.transactions") }}</th>
                    <th>{{ $t("trustDeposit.amount") }}</th>
                  </tr>
                </thead>
              </template>

              <!-- 自定義表格內容（正常顯示資料） -->
              <template v-slot:item="{ item }">
                <tr>
                  <td>{{ item.date }}</td>
                  <template v-for="group in acquirerGroups"> 
                    <td :key="group.acquirerGroup + '-count'" class="border-left">{{ getSettlementData(item.date, group.acquirerGroup, "transactionCount") }}</td>
                    <td :key="group.acquirerGroup + '-amount'">{{ getSettlementData(item.date,  group.acquirerGroup, "totalAmount") }}</td>
                 </template>
                  <!-- <td>
                    <a href="#" @click.prevent="openDialog(item, 'fubon')">
                      {{ formatNumber(item.fubon.transactions) }}
                    </a>
                  </td>

                  <td>
                    <a href="#" @click.prevent="openDialog(item, 'fubon')">
                      {{ formatNumber(item.fubon.amount) }}
                    </a>
                  </td> -->
                  <td class="border-left">{{ formatNumber(item.dailyTotal.transactionCount) }}</td>
                  <td>{{ formatNumber(item.dailyTotal.totalAmount) }}</td>
                </tr>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <!-- Popup Dialog -->
    <!-- <SSRTable ref="detail-list" :data-url="loadDetailUrl" :data-key="'data'" :schema="detailSchema"> </SSRTable> -->

    <!-- <v-dialog v-model="dialog" max-width="500px">
      <v-card>
        <v-card-title>
          <b> {{ selectedType }} </b>
        </v-card-title>
        <v-card-text>
          <div style="text-align: center;">
            {{ $t("trustDeposit.transactionDate") }}: {{ selectedItem.date }}
          </div>
          <SSRTable
            ref="detail-list"
            :data="details"
            :schema="detailSchema"
            :disablePagination="true"
          >
            <div slot="transactions" slot-scope="{ item }">
              {{ formatNumber(item.transactions) }}
            </div>
            <div slot="amount" slot-scope="{ item }">
              {{ formatNumber(item.amount) }}
            </div>
          </SSRTable>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="dialog = false">
            {{ $t("trustDeposit.closeButton") }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog> -->
  </v-container>
</template>

<script>
import SSRTable from "@/components/SSRTable";
import DateRangePicker from "@/components/DateRangePicker";

import axios from "axios";
import moment from "moment";

export default {
  components: {
    SSRTable,
    DateRangePicker
  },

  mounted() {
    if (this.hasAuthoriztion)
      this.fetchDepositReport();
  },

  methods: {
    onDateRangeUpdated(dates) {
      this.dates = dates;
    },
    formatDate(ts) {
      return new Date(ts * 1000).toLocaleString();
    },
    formatNumber(value) {
      if (typeof value !== "number") return value;
      return new Intl.NumberFormat("en-US").format(value);
    },
    // openDialog(item, type) {
    //   this.selectedItem = item;
    //   const typeKey = `trustDeposit.details.${type}`;
    //   this.selectedType = this.$t(typeKey);
    //   this.dialog = true;
    // },
    async fetchDepositReport() {
      try {
        this.loading = true;
        const url =
          `${process.env.VUE_APP_QRPAY_ADMIN_HOST}/trust-deposit/settlements` +
          (this.selectedParamsString
            ? `?${this.selectedParamsString}`
            : "");
        let response = await axios.get(url);
        this.settlements = response.data;
      } catch (err) {
        console.error(`Failed to fetch filter options`, err);
        this.settlements = null;
        throw err;
      } finally {
        this.loading = false;
      }
    },
    getSettlementData(date, acquirerGroup, key) {
      const dailyData = this.dailySettlements.find(item => item.date === date);

      if (!dailyData) {
        console.error(`No data found for date: ${date}`);
        return null;
      }

      // Find the acquirer object within the acquirerGroups array
      const acquirerData = dailyData.acquirerGroups.find(
        acquirer => acquirer.acquirerGroup === acquirerGroup
      );

      // If no data is found for the given acquirer group, return null
      if (!acquirerData) {
        console.error(
          `No data found for acquirer group: ${acquirerGroup} on date: ${date}`
        );
        return null;
      }

      // Return the value of the specified key
      return this.formatNumber(acquirerData[key]);
    }
  },

  data() {
    const today = moment().format("YYYY-MM-DD");
    const startOfMonth = moment()
      .startOf("month")
      .format("YYYY-MM-DD");
    return {
      dialog: false,
      selectedItem: {},
      selectedType: "",
      loading: false,
      dates: [startOfMonth, today],
      scope: {},
      filters: [],
      form: {
        search: {
          searchBy: "",
          keyword: "",
          searchQueryString: ""
        }
      },
      settlements: null
    };
  },
  // watch: {
  //   hasAuthoriztion (newVal) {
  //     console.log('watch allowed', newVal)
  //     if (newVal) this.fetchDepositReport();
  //   }
  // },

  computed: {
    hasAuthoriztion() {
      const allowed = process.env?.VUE_APP_TRUST_DEPOSIT_WHITELIST?.trim() ? process.env.VUE_APP_TRUST_DEPOSIT_WHITELIST?.trim().split(',') : []; 
      const currentUserEmail = this.currentUser.email;
      if (allowed?.length && allowed.includes(currentUserEmail)) {
        return true;
      }
      return false; 
    },
    currentUser() {
      return this.$store.getters.user;
    },
    dailySettlements() {
      return this.settlements?.dailySettlements ?? [];
    },
    acquirerGroups() {
      const defaultGroups = [{
        "acquirerGroup": "FUBON",
        "acquirerName": "北富銀",
      }, {
        "acquirerGroup": "GP",
        "acquirerName": "Global Payments",
      }, {
        "acquirerGroup": "TAISHIN",
        "acquirerName": "台新",
      }];
      // Check if data is a non-empty array
      if (!Array.isArray(this.dailySettlements) || this.dailySettlements.length === 0) {
        // console.error("Input data is not a valid array.");
        return defaultGroups;
      }

      // Find the first daily data object that has an acquirerGroups array
      const firstValidEntry = this.dailySettlements.find(item => item.acquirerGroups && Array.isArray(item.acquirerGroups));

      // If a valid entry is found, map its acquirerGroups to the desired format
      if (firstValidEntry) {
        return firstValidEntry.acquirerGroups.map(acquirer => ({
          acquirerGroup: acquirer.acquirerGroup,
          acquirerName: acquirer.acquirerName
        }));
      }

      // Return an empty array if no valid entry is found
      return defaultGroups;
    },
    selectedParamsString() {
      const entries = Object.entries(this.form.search)
        .filter(([_, value]) => value !== null && value !== "") // 忽略未選取的
        .map(([key, value]) => `${key}=${value}`);

      let paramsString = entries.join("&");
      let from = this.dates.length ? moment(this.dates[0]).unix() : null;
      let to =
        this.dates.length > 1
          ? moment(this.dates[1])
              .endOf("day")
              .unix()
          : null;
      if (from && to) {
        paramsString += paramsString
          ? `&from=${from}&to=${to}`
          : `from=${from}&to=${to}`;
      }

      return paramsString;
    },
    // loadUrl() {
    //   return (
    //     `${process.env.VUE_APP_QRPAY_ADMIN_HOST}/api/operation-logs` +
    //     (this.selectedParamsString
    //       ? `?searchBy=${this.selectedParamsString}`
    //       : "")
    //   );
    // },
    detailSchema() {
      let headers = [
        {
          text: "特店代號",
          sortable: false,
          value: "id"
        },
        {
          text: "筆數",
          align: "end",
          sortable: false,
          value: "transactions"
        },
        {
          text: "金額",
          align: "end",
          sortable: false,
          value: "amount"
        }
      ];

      return headers;
    },

    loadDetailUrl() {
      return (
        `${process.env.VUE_APP_QRPAY_ADMIN_HOST}/api/operation-logs` +
        (this.selectedParamsString
          ? `?searchBy=${this.selectedParamsString}`
          : "")
      );
    },
    user() {
      return this.$store.getters.user;
    },
    userLevelAboveAdmin() {
      return ["superadmin"].indexOf(this.$store.getters.user["level"]) >= 0;
    }
  }
};
</script>

<style scoped>
.truncate-text {
  max-height: 3.6em; /* 約兩行文字高度 */
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: normal;
  display: -webkit-box;
  -webkit-line-clamp: 2; /* 限制顯示行數 */
  -webkit-box-orient: vertical;
}

.v-data-table thead th {
  text-align: center !important;
  vertical-align: middle !important;
  padding: 8px 12px !important;
  height: 48px !important;
  font-size: 14px !important; 
  font-weight: bold !important;
}

.v-data-table td:first-child {
  text-align: center !important;
}

/* 數字欄靠右（從第2欄開始） */
.v-data-table td:not(:first-child) {
  text-align: right !important;
}

.border-left {
  border-left: 1px solid #dee2e6;
}

</style>
